import { Component } from '@angular/core';

@Component({
    selector: 'buttons-group',
    templateUrl: './buttons-group.component.html',
    standalone: true,
    styleUrls: ['./buttons-group.component.scss']
})
export class ButtonsGroupComponent {}
